
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parenting/babynames",
      function () {
        return require("private-next-pages/parenting/babynames/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parenting/babynames"])
      });
    }
  